import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { AppConst, APP_CONSTANT } from 'src/app/core/_constants/app.constant';
import { RouteConstant } from 'src/app/core/_constants/route.constant';
import { PagesService } from 'src/app/core/_services/pages/pages.service';

@Component({
  selector: 'app-add-service-dialog',
  templateUrl: './add-service-dialog.component.html',
  styleUrls: ['./add-service-dialog.component.scss']
})
export class AddServiceDialogComponent implements OnInit {

  serviceForm!: FormGroup;
  validationErrorMessage = APP_CONSTANT.VALIDATION;
  submitted: boolean = false;
  maxLength = AppConst.MAXLENGTH;

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<AddServiceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private service: PagesService, private loader: NgxUiLoaderService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.createForm()
    if (this.data.type == 2) {
      this.serviceForm.patchValue({ serviceName: this.data.data.serviceName })
    }
  }

  createForm() {
    this.serviceForm = this.fb.group({
      serviceName: ['', Validators.required]
    })
  }

  addService() {
    this.submitted = true;
    if (this.serviceForm.valid) {
      this.loader.start();
      if (this.data.type == 1) {
        this.service.post(this.serviceForm.value, `${API_ROUTES.SERVICE.createService}`).pipe().subscribe((response: any) => {
          if (response.status) {
            this.toastr.success(response.msg);
            this.close(true);
          } else {
            this.toastr.error(response);
          }
          this.loader.stop()
        }, (err: any) => {
          this.toastr.error(err.msg);
          this.loader.stop()
        })
      }
      else{
        let data = {
          serviceId: this.data.data._id,
          ...this.serviceForm.value
        }
        this.service.post(data, `${API_ROUTES.SERVICE.updateService}`).pipe().subscribe((response: any) => {
          if (response.status) {
            this.toastr.success(response.msg);
            this.close(true);
          } else {
            this.toastr.error(response);
          }
          this.loader.stop()
        }, (err: any) => {
          this.toastr.error(err.msg);
          this.loader.stop()
        })
      }
    }
  }

  close(value: Boolean) {
    if (this.serviceForm.valid) {
      this.dialogRef.close(value);
    }
  }

  get f() {
    return this.serviceForm.controls;
  }
}
